import { Link } from 'react-router-dom';
import { useVehicles } from '../../../hooks/useVehicles';
import { useMemo } from 'react';

export default function ImpactHero() {
  const { vehicles, loading } = useVehicles();

  const { soldCount, totalDonated } = useMemo(() => {
    const sold = vehicles.filter(v => v.status === 'sold').length;
    return {
      soldCount: sold,
      totalDonated: sold * 100,
    };
  }, [vehicles]);

  return (
    <section className="relative bg-gradient-to-br from-[#1A2332] via-[#2C3E55] to-[#1A2332] text-white pt-16 lg:pt-20 pb-16">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/51e42f43c1f32f54a112085f8dbd118f.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mt-6">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-5">
            <i className="ri-heart-line text-[#E8B84B]"></i>
            <span className="text-sm font-medium">Making a Difference Together</span>
          </div>

          <h1 style={{ fontFamily: 'Oswald, sans-serif' }} className="text-4xl sm:text-5xl md:text-6xl font-bold mb-5 leading-tight">
            Every Car Sold{' '}
            <span className="text-[#E8B84B]">Saves Lives</span>
          </h1>

          <p className="text-base sm:text-xl text-white/90 mb-8 leading-relaxed px-2">
            When you buy from us, you're not just getting a great car—you're helping rescue dogs 
            find their forever homes through our partnership with Oregon Dog Rescue.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-3 px-4 sm:px-0">
            <Link
              to="/inventory"
              className="inline-flex items-center justify-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
            >
              <i className="ri-car-line text-xl"></i>
              Shop &amp; Give Back
            </Link>
            <a
              href="https://www.oregondogrescue.org"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-external-link-line text-xl"></i>
              Visit Oregon Dog Rescue
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-4 mt-10">
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-money-dollar-circle-line text-[#4ADE80] text-xl"></i>
              <span>
                {loading ? 'Loading...' : totalDonated > 0 ? `$${totalDonated.toLocaleString()} Donated` : 'Growing with Every Sale'}
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-car-line text-[#4ADE80] text-xl"></i>
              <span>{loading ? 'Loading...' : `${soldCount} ${soldCount === 1 ? 'Car' : 'Cars'} Sold`}</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-hand-heart-line text-[#4ADE80] text-xl"></i>
              <span>$100 Per Sale</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}